import PropTypes from "prop-types";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Database, Ellipsis, Eye } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import EventDatasetDialog from "routes/meta_datasets/swoogo_events/EventDatasetDialog";

const EventActions = ({ eventId, canSetDataset = false }) => {
  const navigate = useNavigate();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Event actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          <DropdownMenuItem
            onClick={() => navigate(`/swoogo/events/${eventId}`)}
          >
            <Eye />
            View details
          </DropdownMenuItem>
          {canSetDataset && (
            <DropdownMenuItem onClick={() => setIsDialogOpen(true)}>
              <Database />
              Attach dataset
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      {canSetDataset && isDialogOpen && (
        <EventDatasetDialog
          eventIds={[eventId]}
          open
          onOpenChange={setIsDialogOpen}
        />
      )}
    </>
  );
};

EventActions.propTypes = {
  eventId: PropTypes.number.isRequired,
  canSetDataset: PropTypes.bool,
};

export default EventActions;
